
export default class GHPlane extends THREE.Plane {
  constructor (origin, xAxis, yAxis) {
    let normal = new THREE.Vector3();
    normal = normal.crossVectors(xAxis, yAxis);
    super(normal, origin.length());

    this.origin = origin;
    this.xAxis = xAxis;
    this.yAxis = yAxis;
  }

  get center () {
    return this.origin;
  }

  translate (v) {
    this.origin.add(v);
  }

  project (point) {
    let projected = point.clone().projectOnPlane(this.normal);
    return new THREE.Vector2(
      this.xAxis.dot(projected) - this.xAxis.dot(this.origin),
      this.yAxis.dot(projected) - this.yAxis.dot(this.origin)
    );
  }

  flipZ () {
    this.origin = new THREE.Vector3(this.origin.x, this.origin.z, this.origin.y);
    this.normal = new THREE.Vector3(this.normal.x, this.normal.z, this.normal.y);
    this.xAxis = new THREE.Vector3(this.xAxis.x, this.xAxis.z, this.xAxis.y);
    this.yAxis = new THREE.Vector3(this.yAxis.x, this.yAxis.z, this.yAxis.y);
  }

  clone () {
    let plane = new GHPlane(this.origin.clone(), this.xAxis.clone(), this.yAxis.clone());
    plane.normal = this.normal.clone();
    return plane;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/math/GHPlane.js